import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CustomerService } from "@modules/private/customer/data/services/view/customer.service";
import { ChannelSourcesViewService } from "@modules/private/omnichannel/data/services/view/channel-sources-view.service";

@Component({
  selector: 'app-customer-new',
  templateUrl: './customer-new.component.html',
  styleUrls: ['./customer-new.component.scss']
})
export class CustomerNewComponent implements OnInit {
  kinds: { label: string; value: string; }[] = [
    { label: "Persona Fisica", value: "Física" },
    { label: "Persona Moral", value: "Moral" },
  ]

  nationalities: { label: string; value: string; }[] = [
    { label: "Mexicana", value: "MEXICAN" },
    { label: "Otra", value: "OTHER" },
  ]

  //* Omnicanal: opciones de canal de origen (override manual; el backend auto-resuelve por actor)
  channelOptions$: Observable<{ label: string; value: string }[]>

  constructor(
    public customerService: CustomerService,
    private channels: ChannelSourcesViewService
  ) {
    this.channelOptions$ = this.channels.sources$.pipe(
      map(list => list.filter(s => s.active).map(s => ({ label: s.label, value: s.key })))
    )
  }

  ngOnInit(): void {
    this.channels.loadAll(1, 100)
  }

  get e() {
    return this.customerService.entity
  }

  getKindCategory(id: string) {
    return this.kinds.find(c => c.value === id)?.label
  }

  getNationality(id: string) {
    return this.nationalities.find(c => c.value === id)?.label
  }

  onEntityChange(entityValue: string) {
    if (entityValue === 'Física') {
      this.customerService.formMethod = 'CREATE_PHYSICAL_PERSON';
    } else if (entityValue === 'Moral') {
      this.customerService.formMethod = 'CREATE_MORAL_PERSON';
    }
    
    this.customerService.newEntity();
  }
  
}
